/*
 *
 * Modal constants
 *
 */

// actions
export const SHOW_MODAL = 'app/Modal/SHOW_MODAL';
export const HIDE_MODAL = 'app/Modal/HIDE_MODAL';

// modal names
export const CREATE_COHORT_MODAL = 'CREATE_COHORT_MODAL';
export const CREATE_COHORT_COURSEWARE_MODAL = 'CREATE_COHORT_COURSEWARE_MODAL';
